import {
  IonSearchbar,
  IonList,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonIcon,
} from "@ionic/react";
import "./SearchwithSelect.scss";
import { useState } from "react";
import { useHistory } from "react-router";
import React from "react";
import GlobalSearchPage from "./GlobalSearch";
import GlobalTeamSearch from "../GlobalTeamSearch/GlobalTeamSearch";
import { chevronBackOutline } from "ionicons/icons";
import GlobalUnitSearch from "../GlobalUnitSearch/GlobalUnitSearch";
import GlobalDeptSearch from "../GlobalDeptSearch/GlobalDeptSearch";
import GlobalSpecialitySearch from "../GlobalSpecialitySearch/GlobalSpecialitySearch";
import { useTranslation } from "react-i18next";

const SearchWithSelectBar: React.FC<any> = () => {
   const {t} = useTranslation("home");
  const [selectValue, setSelectvalue] = useState<any>("Provider by name");
  const string1 = selectValue;
  const string2 = "Provider by Speciality";


  const getPlaceholder = () => {
  switch (selectValue) {
    case "PROVIDER_BY_NAME":
    case "PROVIDER_BY_SPECIALITY":
      return t("FILTER_BY_PROVIDER");
    case "TEAM":
      return t("FILTER_BY_TEAM");
    case "UNITS":
      return t("FILTER_BY_UNITS");
    case "DEPARTMENTS":
      return t("FILTER_BY_DEPARTMENTS");
    default:
      return t("Search");
  }
};

  const placeholderValue =
    selectValue === string2
      ? "Filter by provider"
      : string1 === "Provider by name"
      ? "Filter by Provider"
      : `Filter by ${selectValue}`;

  const [searchInput, setSearchInput] = useState("");
  const [pageNo, setPageNo] = useState(1);

  let history = useHistory();

  const handleSearchInput = (e: any) => {
    setSearchInput(e.detail.value);
  };
  const handleSelectionChange = (event: any): void => {
    setSelectvalue(event.detail.value);
  };

 const OPTIONS = [
  { key: "PROVIDER_BY_NAME", value: "Provider by name" },
  { key: "PROVIDER_BY_SPECIALITY", value: "Provider by Speciality" },
  { key: "TEAM", value: "Team" },
  { key: "UNITS", value: "Units" },
  { key: "DEPARTMENTS", value: "Departments" },
];

  return (
    <>
      <div className="file-share-list-container">
        <div className="file-share-select-user-header">
          <div
            className="back-icon"
            onClick={() => {
              history.push("/client/home")
            }}
          >
            <IonIcon icon={chevronBackOutline} />
          </div>
        <div className="header-label">{t("Search")}</div>
          <div className="add-fav-user-btn-container"></div>
        </div>
      </div>

      <div className="search-bar">
        <div className="search-bar-container">
          <div className="selection-box-container">
            <>
              <IonList className="list-wrapper">
                <IonItem className="ion-item">
                 <IonSelect
  aria-label="option"
  onIonChange={handleSelectionChange}
  interface="popover"
  value={selectValue}
  className="select-box"
>
  {OPTIONS.map((option, index) => (
    <IonSelectOption key={index} value={option.value}>
      {t(option.key)}
    </IonSelectOption>
  ))}
</IonSelect>
                </IonItem>
              </IonList>
            </>
          </div>
          <div className="search-box-container">
         <IonSearchbar
  onIonChange={(event: any) => handleSearchInput(event)}
  className="search-box"
  placeholder={getPlaceholder()}
  showClearButton="always"
  searchIcon={""}
/>
          </div>
        </div>
      </div>

      {selectValue === "Provider by name" ? (
        <GlobalSearchPage searchInput={searchInput} pageNo={pageNo} />
      ) : selectValue === "Units" ? (
        <GlobalUnitSearch searchInput={searchInput} />
      ) : selectValue === "Team" ? (
        <GlobalTeamSearch fromSelectDropdown={true} searchInput={searchInput} />
      ) : selectValue === "Departments" ? (
        <GlobalDeptSearch searchInput={searchInput} />
      ) : selectValue === "Provider by Speciality" ? (
        <GlobalSpecialitySearch searchInput={searchInput} />
      ) : null}
    </>
  );
};

export default SearchWithSelectBar;
